<form (submit)="saveFunction()">
  <div class="croppie-section" [style.width]="widthRatio">
    <div class="cropping-ratio selected" [style.padding-bottom]="heightRatio">
      @if (timeout) {
        <curbnturf-cropping
          #cropper
          [croppieOptions]="croppieOptions"
          [outputFormatOptions]="options?.output"
          [imageUrl]="croppieImage"
          [points]="[0, 0, 400, 400]"
          (result)="newImageResultFromCroppie($event)"
        >
        </curbnturf-cropping>
      }
    </div>
    <ng-container>
      <input
        name="caption"
        type="text"
        [(ngModel)]="caption"
        class="text-input w-input"
        placeholder="Enter a Caption"
      />
    </ng-container>
    <div class="warning-notice">
      <strong>Note:</strong> The entire image will be used for the zoom view on your property.
    </div>
  </div>
  <div class="photo-wrapper">
    <input
      type="file"
      id="file-upload"
      #imageUpload
      (change)="imageUploadEvent($event)"
      accept="image/jpeg, image/png"
      hidden
    />
    <ng-container>
      <button type="button" class="cnt-button cnt-button-rotate-icon" (click)="rotateDir('l')">
        <curbnturf-misc-svg icon="rotateLeft"></curbnturf-misc-svg>
      </button>
      <button type="button" class="cnt-button cnt-button-rotate-icon" (click)="rotateDir('r')">
        <curbnturf-misc-svg icon="rotateRight"></curbnturf-misc-svg>
      </button>
      <button type="button" class="cnt-button" (click)="cancelCroppieEdit()">
        <div class="cnt-button-copy">Cancel</div>
      </button>
      <button type="submit" class="cnt-button photo-save">
        <div class="cnt-button-copy">{{ submitButtonText }}</div>
      </button>
    </ng-container>
  </div>
</form>
